import styled from '@emotion/styled';
import { ButtonLinkWithIcon } from '@blueprint/ui';

export const StyledMapIconLink = styled(ButtonLinkWithIcon)(`
    min-width: unset;
    padding-left: 0;
    padding-right: 0;
`);
